import React from 'react';
import Icon from '@ant-design/icons/lib/components/Icon';
import CoinStack from './CoinStackOutlined.svg';

// eslint-disable-next-line react/require-default-props
const CoinStackOutlined = function (props: React.ComponentProps<typeof Icon>) {
  return (
    <Icon {...props} component={CoinStack} viewBox="10 10 180 180" />
  );
};

export default CoinStackOutlined;
